import React, { useEffect, useState } from 'react';

// Foto que vem do servidor com o login (o banco é o da empresa logada): <img src> direto não manda o
// token, por isso é buscada com fetch e mostrada como blob. Clicar abre a foto inteira.
export default function FotoAutenticada({ src, alt, style }) {
  const [url, setUrl] = useState(null);

  useEffect(() => {
    let ativo = true;
    let objectUrl = null;
    setUrl(null);
    fetch(src)
      .then(r => (r.ok ? r.blob() : null))
      .then(blob => {
        if (!ativo || !blob) return;
        objectUrl = URL.createObjectURL(blob);
        setUrl(objectUrl);
      })
      .catch(() => { if (ativo) setUrl(null); });
    return () => {
      ativo = false;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [src]);

  if (!url) return <div style={{ ...style, display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#fff3e0' }}><span style={{ fontSize: 24, opacity: 0.5 }}>📷</span></div>;

  return <img src={url} alt={alt} title="Clique para ver a foto inteira" onClick={() => window.open(url, '_blank')} style={{ ...style, cursor: 'zoom-in' }} />;
}
